import { memo as reactMemo } from 'react';
const memo = (component, comparator) => {
    return reactMemo(component, comparator);
};
export { memo };
